import React from 'react';
import '../style.css';
import WalletConnection from './WalletConnection';
import WalletConnectionMobile from './WalletConnectionMobile';


const WalletGroup = ({ contents = [] }) => (
    <div>
        <div className='desktop'>
            {contents.map((content, index) => (
                <WalletConnection key={index} content={content} image={content.image} section={index + 1} />
            ))}
        </div>
        
        <div className='ipad'>
            {contents.map((content, index) => (
                <WalletConnection key={index} content={content} image={content.image} section={index + 1} />
            ))}
        </div>

        <div className='mobile'>
            {contents.map((content, index) => (
                <WalletConnectionMobile key={index} content={content} image={content.image} section={index} />
            ))}
        </div>
    </div>

)

export default WalletGroup